import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PageTemplate from '../../components/template/PageTemplate';
import { HOME_TYPE, WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import PageWidgetListContainer from '../../containers/widget/HomeWidgetListContainer';
import { widgetActions } from '../../store/modules/widget';

const SubPageWidgetList = (props) => {
  const { getSubPageWidgetList } = props;
  const { id } = useParams();

  const getList = useCallback(() => {
    if (id) {
      getSubPageWidgetList({
        homeId: id,
      });
    }
  }, [id, getSubPageWidgetList]);

  useEffect(() => {
    getList();
  }, [getList]);

  return (
    <PageTemplate pageName={WIDGET_PAGE_NAME.SUB_PAGE_MANAGEMENT}>
      <PageWidgetListContainer homeType={HOME_TYPE.SUB} getList={getList} />
    </PageTemplate>
  );
};

const mapDispatchToProps = {
  getSubPageWidgetList: widgetActions.getSubPageWidgetList,
};

export default connect(null, mapDispatchToProps)(SubPageWidgetList);
